import commonGetters from 'top20common/distribution/store/getters';

export default {
  ...commonGetters,
  userErrorState: state => {
    return state.userState.error;
  },
  loginFormState: state => {
    return state.loginForm;
  },
  userState: state => {
    return state.userState;
  },
  getEmailConfirmationStatus: state => {
    return state.emailConfirmation;
  },
  getPasswordResetConfirmationStatus: state => {
    return state.resetConfirmation;
  },
  getResetErrors: state => {
    let error;
    let errors = [];
    for (error in state.resetConfirmation.errors) {
      if (error !== 'new_password1' && error !== 'new_password2') {
        errors.push({
          [error]: state.resetConfirmation.errors[error]
        });
      }
    }
    return errors;
  },
  getResetPasswordForm: state => {
    return state.resetPasswordForm;
  },
  getNewPassword: state => {
    return state.changePasswordForm.password;
  },
  getChangePasswordError: state => {
    return state.changedPasswordConfirmation.error;
  },
  getChangePasswordConfirmation: state => {
    return state.changedPasswordConfirmation;
  },
  companiesOfInterestFormState: state => {
    return state.companiesOfInterestFormState;
  },
  savedSearchesState: state => {
    return state.savedSearchesState;
  },
  isUserAccountApproved: state => {
    const userDetail = state.userState.details;
    if (userDetail) {
      return userDetail.account_status === 'approved' || userDetail.account_status === 'subscribed';
    }
  },
  allFiltersState: state => {
    return state.filtersState.all || {};
  },
  filtersLoadingState: state => {
    return state.filtersState.loading;
  },
  companiesOfInterestErrorState: state => {
    return state.companiesOfInterestErrorState;
  },
  countSavedCompaniesOfInterestState: state => {
    return state.countSavedCompaniesOfInterestState;
  },
  referrerProfileState: state => {
    return state.referrerProfileState;
  }
};
